// Renders an office brief for night-sort staff. Shared by the sorter portal (where it is
// read and acknowledged) and the office's Briefs tab (the preview), so the preview is
// exactly what lands on the phone.
// Brief text is plain lines: "## Heading", "- bullet", "1. step", **bold**, blank = gap.
function briefInline(text) {
  return text.split(/(\*\*[^*]+\*\*)/g).map((part, i) =>
    /^\*\*[^*]+\*\*$/.test(part) ? <strong key={i}>{part.slice(2, -2)}</strong> : part);
}
export default function BriefText({ text }) {
  const blocks = [];
  let list = null;
  const flush = () => { if (list) { blocks.push(list); list = null; } };
  (text || '').split('\n').forEach((raw) => {
    const line = raw.trim();
    const bullet = /^[-•]\s+(.*)$/.exec(line);
    const step = /^(\d+)[.)]\s+(.*)$/.exec(line);
    if (bullet || step) {
      const kind = bullet ? 'ul' : 'ol';
      if (!list || list.kind !== kind) { flush(); list = { kind, items: [] }; }
      list.items.push(bullet ? bullet[1] : step[2]);
      return;
    }
    flush();
    if (!line) return;
    if (line.startsWith('## ')) blocks.push({ kind: 'h', text: line.slice(3) });
    else blocks.push({ kind: 'p', text: line });
  });
  flush();
  return (
    <div style={{ fontSize: '0.92rem', lineHeight: 1.55 }}>
      {blocks.map((b, i) => {
        if (b.kind === 'h') return <div key={i} style={{ fontWeight: 800, color: 'var(--hp-gold)', margin: '16px 0 6px' }}>{briefInline(b.text)}</div>;
        if (b.kind === 'p') return <p key={i} style={{ margin: '0 0 10px' }}>{briefInline(b.text)}</p>;
        const L = b.kind === 'ul' ? 'ul' : 'ol';
        return <L key={i} style={{ margin: '0 0 10px', paddingLeft: 22 }}>{b.items.map((t, j) => <li key={j} style={{ marginBottom: 5 }}>{briefInline(t)}</li>)}</L>;
      })}
    </div>
  );
}

